import axios from "axios";
import { GetLinksByCountry } from "./GetLinksByCountryAction";
import {
  editLinkRequested,
  editLinkRequestSucceeded,
  editLinkRequestFailed,
} from "../slices/EditLinkSlice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Menu/EditLink`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

const getSelectedCountryId = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData || !selectedCountry) {
    return null;
  }

  const session = JSON.parse(sessionData);
  const country = (session.rols || [])
    .map((entry) => entry.country)
    .find((item) => item?.countryName === selectedCountry);

  return country?.idcountry ?? null;
};

const getSessionUserName = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData) {
    return "";
  }

  const session = JSON.parse(sessionData);
  return session.employeeId || session.employeeId || "";
};

export const EditLink = (link) => async (dispatch) => {
  try {
    dispatch(editLinkRequested());

    const putData = {
      idmenuLevel3Links: Number(link.idmenuLevel3Links),
      name: link.name,
      url: link.url,
      isActive: link.isActive ?? true,
      createdBy: link.createdBy,
      createdDate: link.createdDate,
      modifiedBy: getSessionUserName(),
      modifiedDate: new Date().toISOString(),
      idmenuLevel1: Number(link.idmenuLevel1),
      idmenuLevel2: Number(link.idmenuLevel2),
      idcountry: Number(link.idcountry ?? getSelectedCountryId()),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.put(apiUrl, putData, axiosConfig);

    if (response.data === true) {
      dispatch(editLinkRequestSucceeded(response.data));
      await dispatch(GetLinksByCountry());
      return { success: true, message: "Link updated successfully" };
    }

    const errorMessage = "The link could not be updated. Please try again.";
    dispatch(editLinkRequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(editLinkRequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
